import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13ed47f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delete-streak-modal__message" }, " Are you sure you want to delete this streak? ", -1))

import { ref } from 'vue';

import DSModal from '@/design-system/DSModal.vue';

import { useStore } from '@/store';
import StreakInterface from '@/interfaces/Streak.interface';
import { DELETE_STREAK } from '@/store/types/actions';


export default /*#__PURE__*/_defineComponent({
  __name: 'DCDeleteStreak',
  setup(__props, { expose: __expose }) {

const store = useStore();
const show_modal = ref(false);
const request_pending = ref(false);
const streak = ref({} as StreakInterface);

const handleDeleteStreak = async () => {
  request_pending.value = true;

  if (streak.value.id) {
    await store.dispatch(DELETE_STREAK, streak.value);
    show_modal.value = false;
  }

  request_pending.value = false;
};

const handleCancel = () => {
  show_modal.value = false;
};

const handleOpenModal = (deletable_streak: StreakInterface) => {
  streak.value = deletable_streak;
  show_modal.value = true;
};

__expose({ show_modal, handleOpenModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DSModal, {
    modelValue: show_modal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show_modal).value = $event)),
    title: "Delete Streak",
    loading: request_pending.value,
    "confirm-label": "Delete Streak",
    variant: "danger",
    onConfirm: handleDeleteStreak,
    onCancel: handleCancel
  }, {
    body: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["modelValue", "loading"]))
}
}

})